import Axios from "axios";
import Cookies from "js-cookie";
import { ApiUrls } from "../constant/api.constant";

export const updateUserToken = async (token: any) => {
  try {
    const refreshToken = Cookies.get("refreshToken") || token;
    if (!refreshToken) {
      throw new Error("Missing refresh token");
    }

    const res = await Axios.post(
      ApiUrls.refreshTokenUrl,
      { refresh: refreshToken }
    );
    if (res.data) {
      if (res.data.access) {
        Cookies.set("token", res.data.access, { expires: 10, sameSite: "strict" });
        Cookies.set("accessToken", res.data.access, { expires: 10, sameSite: "strict" });
      }
      if (res.data.refresh) {
        Cookies.set("refreshToken", res.data.refresh, { expires: 10, sameSite: "strict" });
      }
    }
    return res.data;
  } catch (e: any) {
    Cookies.remove("token");
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    throw new Error(e?.message);
  }
};